import React from "react";
import PropTypes from "prop-types";

import {
  Card,
  Divider,
  CardContent,
  Modal,
  Box,
  Button,
  Typography,
  Alert,
} from "@mui/material";

const DeleteKeywordModal = (props) => {
  const { handleClose, handleConfirm, open, numSelected } = props;

  return (
    <Modal open={open} onClose={handleClose}>
      <Card
        sx={{
          maxWidth: { xs: "90%", sm: "400px", md: "500px" },
          m: "10% auto 0 auto",
        }}
        data-testid="manage-keywords-delete-modal"
      >
        <CardContent>
          <Typography variant="h6" sx={{ mb: 2.5 }}>
            {`Delete ${numSelected === 1 ? "Keyword" : "Keywords"}`}
          </Typography>
          <Alert severity="error">Are you sure? This can't be undone</Alert>
        </CardContent>
        <Divider />
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            p: 2,
          }}
        >
          <Button onClick={handleClose} sx={{ mr: 1 }}>
            Cancel
          </Button>
          <Button onClick={handleConfirm} color="error" variant="outlined">
            {`Delete ${numSelected === 1 ? "Keyword" : "Keywords"}`}
          </Button>
        </Box>
      </Card>
    </Modal>
  );
};

DeleteKeywordModal.propTypes = {
  open: PropTypes.bool.isRequired,
  numSelected: PropTypes.number.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleConfirm: PropTypes.func.isRequired,
};

export default DeleteKeywordModal;
